import Hls from 'hls.js';

export const formatQualityLabel = (hls: Hls, levelIndex: number): string => {
  if (hls) {
    const level = hls.levels[levelIndex];

    if (level.name) {
      return level.name;
    } else {
      if (level.height) {
        return `${level.height}p`;
      } else {
        if (level.bitrate) {
          return Math.round(level.bitrate / 1024) + 'kb';
        } else {
          return '';
        }
      }
    }
  }

  return '';
};
